import { useNavigate, NavLink } from 'react-router-dom';
import {
	Layout,
	message,
	Row,
	Col,
	Card,
	Form,
	Input,
	Button,
	Space,
	Typography,
	Divider
} from 'antd';
import { login } from '../../store/auth/actions';
import { useDispatch, useSelector } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { LockOutlined } from '@ant-design/icons';
import { reset } from 'numeral';
import ResetPassword from './resetPassword';
import { useState } from 'react';
const logoBE = require('../../assets/onboarding/logoBE.png');
const EV = require('../../assets/EngelLogo.png');
const EVMoBile = require('../../assets/EngelLogoMobile.png');

const { Content } = Layout;
const { Text } = Typography;

const LoginPage = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const errorLogin = useSelector((state) => state.auth.error);

	const onFinish = async (values) => {
		dispatch(login({ username: values.username, password: values.password, navigate }));
	};

	const onFinishFailed = () => {
		message.error('Debe completar todos los datos');
	};

	return (
		<Layout
			style={{
				width: isMobileOnly ? 400 : undefined,
				marginTop: -5,
				background: '#FCFAF5'
			}}>
			<div style={{ height: isMobileOnly ? 56 : 68, background: 'white' }}>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
					{isMobileOnly ? (
						<img src={EVMoBile} alt="EV" style={{ width: 109, height: 24 }}></img>
					) : (
						<img src={EV} alt="EV" style={{ width: 212, height: 16 }}></img>
					)}
				</div>
			</div>
			<Content
				style={{
					marginTop: !isMobileOnly ? '5%' : undefined,

					height: !isMobileOnly ? '100vh' : undefined,
					padding: isMobileOnly && 24,
					height: '100vh',
					marginRight: !isMobileOnly ? undefined : 8
				}}>
				<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
					<Text
						className="title-head"
						style={{ fontSize: isMobileOnly ? 20 : 32, fontWeight: 700, color: '#262626' }}>
						{t('login.text')}
					</Text>
				</div>
				<Row justify="space-around" align="middle">
					<Col lg={6} md={12} xs={24} sm={24}>
						<Card className="card-login">
							<Form name="login" onFinish={onFinish} onFinishFailed={onFinishFailed}>
								<Form.Item
									name="username"
									rules={[{ required: true, message: 'Introduzca su email' }]}>
									<Input
										className={'login-input'}
										type="email"
										placeholder={t('login.user') + '*'}
									/>
								</Form.Item>
								<Form.Item
									name="password"
									rules={[
										{
											required: true,
											message: 'Por favor, introduzca su contraseña'
										}
									]}>
									<Input.Password className={'login-input'} placeholder={t('login.pass') + '*'} />
								</Form.Item>

								<div className="register">
									<NavLink to="/auth/forgot-password">
										<Text style={{ color: '#404040', fontSize: 14, fontWeight: 400 }}>
											{t('login.resetPassword')}
										</Text>
									</NavLink>
								</div>
								{errorLogin && (
									<div style={{ marginBottom: 24 }}>
										<Text style={{ color: 'red', fontSize: 16 }}>{t('login.errorEV')}</Text>
									</div>
								)}
								<Form.Item>
									<Button
										htmlType="submit"
										block
										className="button-secundary-ev"
										style={{ height: isMobileOnly && 48 }}>
										{t('login.login')}
									</Button>
								</Form.Item>
							</Form>
						</Card>
					</Col>
				</Row>
			</Content>
		</Layout>
	);
};

export default LoginPage;
